module.exports = __webpack_public_path__ + "static/Plain-Light-8bc3b559d9a2374a88f2dc61500724f9.woff";